import { render, staticRenderFns } from "./MoviePoster.vue?vue&type=template&id=7f5800d8&scoped=true&"
import script from "./MoviePoster.vue?vue&type=script&lang=js&"
export * from "./MoviePoster.vue?vue&type=script&lang=js&"
import style0 from "./MoviePoster.vue?vue&type=style&index=0&id=7f5800d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5800d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomSheet,VBtn,VCard,VCardText,VCardTitle,VIcon})
